import React from 'react';
import { MessageContainer } from './MessageContainer';
import { MessageModel, Citation } from '../types/models';

const EMPTY_CITATIONS: Citation[] = [];

interface MessageListProps {
	chatContainerRef: React.RefObject<HTMLDivElement | null>;
	chatHistory: MessageModel[];
	isGenerating: boolean;
	handleFeedback: (index: number, value: -1 | 1) => void;
	selectedModel: string;
	onEditMessage?: (index: number, newContent: string) => void;
	getHighlightData?: (messageIndex: number) => any;
}

export function MessageList({
	chatContainerRef,
	chatHistory,
	isGenerating,
	handleFeedback,
	selectedModel,
	onEditMessage,
	getHighlightData,
}: MessageListProps) {
	return (
		<div
			className="overflow-y-auto pt-[25px] h-full max-h-[80vh] relative"
			ref={chatContainerRef}
		>
			{chatHistory && chatHistory.length > 0 ? (
				chatHistory.map((message, index) => {
					const highlightData = getHighlightData
						? getHighlightData(index)
						: null;
					return (
						<MessageContainer
							key={index}
							isVisible={!isGenerating}
							message={message}
							handleFeedback={handleFeedback}
							model={selectedModel}
							citations={message?.citations || EMPTY_CITATIONS}
							messageIndex={index}
							onEditMessage={onEditMessage}
							searchQuery={highlightData?.query}
							searchMatches={highlightData?.matches}
							currentMatchIndexInMessage={
								highlightData?.currentMatchInMessage
							}
							isStreaming={
								isGenerating &&
								index === chatHistory.length - 1
							}
						/>
					);
				})
			) : (
				<div className="w-full h-full flex justify-center items-center relative">
					<div style={{ marginBottom: '100px' }}>
              <div className="text-[14px] md:text-[28px] text-white whitespace-nowrap overflow-hidden w-fit relative border-r-2 border-white animate-typing-blink select-none pointer-events-none">
							What is your mission? I&apos;m here to help.
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
